import {formatDate} from "../helper/date";

const html_entities = {
    amp: '&',
    apos: '\'',
    gt: '>',
    lt: '<',
    quot: '"'
};

export const initialState = () => {
    const storeState = document.getElementById('tn-travel-filter-store');
    if (storeState) {

        return JSON.parse(
            storeState.text
                .replace(
                    /&(apos|quot|gt|lt|amp);/g,
                    function () { return html_entities[arguments[1]]; }
                )
        );
    }

    return {
        filter: {
            search: '',
            price_range: [0, 3000],
            date_range: [formatDate(new Date()), null],
            durations: [],
            type_of_travel: [],
            means_of_travel: [],
            travel_feature: [],
            travel_destination: [],
            travel_country: [],
            travel_region: [],
            travel_city: [],
        },
        paged: {
            page_num: 1,
            page_size: 20,
            total: 0
        },
        sort: {
            order_by: 'date',
            order: 'ASC'
        },
        render_type: 'list', // list or grid
        facets: {
            price_range: [],
            durations: [],
            taxonomies: {}
        },
        options: {
            target: '',
            url: '',
        },
        html: false
    };
};

export const state = initialState();
